import request from '../utils/request'

const accountService = {
  get: (recalc) => {
    return request({
      url: '/account/get',
      method: 'post',
      data: { recalc }
    })
  },
  createOrUpdate: (data) => {
    return request({
      url: '/account/createOrUpdate',
      method: 'post',
      data
    })
  },
  listCards: () => {
    return request({
      url: '/account/cards/list',
      method: 'post'
    })
  },
  addCard: (data) => {
    return request({
      url: '/account/cards/add',
      method: 'post',
      data
    })
  },
  removeCard: (id) => {
    return request({
      url: '/account/cards/remove',
      method: 'post',
      data: { id }
    })
  },
  listTx: (params) => {
    return request({
      url: '/account/tx/list',
      method: 'post',
      data: params
    })
  },
  exportTx: (params) => {
    return request({
      url: '/account/tx/export',
      method: 'post',
      data: params
    })
  },
  withdraw: (data) => {
    return request({
      url: '/account/withdraw',
      method: 'post',
      data
    })
  },
  invest: (data) => {
    return request({
      url: '/account/invest',
      method: 'post',
      data
    })
  },
  recharge: (data) => {
    return request({
      url: '/account/recharge',
      method: 'post',
      data
    })
  },
  getAvailableAgreements: () => {
    return request({
      url: '/account/agreements',
      method: 'post'
    })
  },
  getChartData: (params) => {
    return request({
      url: '/account/tx/chart',
      method: 'post',
      data: params
    })
  },
  listInvestedProjects: () => {
    return request({
      url: '/account/invested/projects',
      method: 'post'
    })
  }
}

export default accountService

